"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cubed = void 0;
var UnitTimes = require("./unit-times");
function Cubed(name, u) {
    var area = UnitTimes.lengthByLength(name, u, u);
    return UnitTimes.areaByLength(name, area, u);
    // TODO was return u.Times < IArea > (u).Times < IVolume > (u);
}
exports.Cubed = Cubed;
//# sourceMappingURL=unit-cubed.js.map